// extracted by mini-css-extract-plugin
export default {"central_draw":"base_modal_central_draw__0WL2y","central_draw_content":"base_modal_central_draw_content__J2xCu"};